import API from "serviceshift-ui/api-client";

export default {
  fetchPriceSheets({ commit }) {
    return API.pricing.getAllPriceSheets().then((res) => {
      commit("replace", {
        state: "priceSheets",
        data: res.data,
      });
    });
  },
};
